import EventBus from './Event';
import Modal from './Modal';
import { agentGetInfo, agentGetClients } from './api_client/api_reagent';
import { preqGetFields } from './api_client/api_prequalification';

class AgentsClientsTable {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$body = this.$el.find('[data-clients-table="body"]');
    this.$template = this.$el.find('[data-clients-row-template]');
    this.$tplClone = this.$template.clone();

    this.$template.remove();
    this.clients = [];

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    EventBus.on('user:loaded', this.initTable.bind(this));

    this.$el.find('[data-clients-table="body"]')
      .on('click', '[data-clients-table="actions-trigger"]', this.onActionsTrigger.bind(this))
      .on('click', '[data-clients-table="actions-details"]', this.onActionsDetails.bind(this))
      .on('click', '[data-clients-table="actions-cancel"]', this.onActionsCancel.bind(this))
  }

  async initTable() {
    const user = window.grapp.user;
    if (!user) {
      console.error('No user found');
      return;
    }

    await this.getAgentClients(user.auth.email);
    this.render();
  }

  async getAgentClients(email) {
    const user = window.grapp.user;

    const agentInfoReq = await agentGetInfo(user.auth.email);
    // console.log('agentInfoReq: ', agentInfoReq);
    if (agentInfoReq.success && agentInfoReq.reagent) {
      const clientsList = agentInfoReq.reagent.reagent_clients_list.split(',');
      if (!clientsList.length) {
        this.clients = [];
        return;
      }

      const clientsReqs = await Promise.all(clientsList.map(async client => {
        const clientPreqReq = await preqGetFields(client);
        if (clientPreqReq.success) {
          return clientPreqReq;
        } else {
          return [];
        }
      }));
      // console.log('clientsReqs: ', clientsReqs);
      this.clients = clientsReqs.filter(clientReq => clientReq.success).map(client => {
        const coapplicants = [];
        const coappFields = Object.keys(client.fields).filter(key => key.startsWith('preq_coapp_'));
        coappFields.forEach(key => {
          const index = key.split('_').pop();
          const coapp = coapplicants.find(c => c.index === index) || { index };
          let newKey = key.split('_').slice(2).join('_').slice(0, -2);
          
          coapp[newKey] = client.fields[key];
          if (!coapplicants.find(c => c.index === index)) {
            coapplicants.push(coapp);
          }
        });
        // console.log('coapplicants: ', coapplicants);
        
        return {
          first_name: client.fields.preq_legal_first_name,
          last_name: client.fields.preq_legal_last_name,
          email: client.fields.preq_owner_user,
          phone: client.fields.preq_phone_number,
          coapplicants,
        };
      });
      console.log('this.clients: ', this.clients);

      await this.getAgentClientsInfo();
    } else {
      console.log('No clients found');
    }
  }

  async getAgentClientsInfo() {
    const user = window.grapp.user;
    
    const agentClientsReq = await agentGetClients(user.auth.email);
    // console.log('agentClientsReq: ', agentClientsReq);
    if (agentClientsReq.success && agentClientsReq.clients) {
      const clients = agentClientsReq.clients;
      this.clients.forEach(client => {
        const clientInfo = clients.find(c => c.data?.auth?.email === client.email);
        if (!clientInfo || !clientInfo.data) {
          console.log('no client info found for: ', client.email);
          client.app_status = '--';
          client.deal_status = 'None Active';
          return;
        }
        const clientPlans = clientInfo.data?.planConnections;
        if (clientPlans && clientPlans.length) {
          const approved = clientPlans.find(plan => plan.planName === "Applicants-Approved");
          const denied = clientPlans.find(plan => plan.planName === "Applicants-Denied");

          if (approved) {
            client.app_status = 'Approved';
          } else if (denied) {
            client.app_status = 'Denied';
          } else {
            client.app_status = 'Pending Approval';
          }
        }
        const clientDealStatus = clientInfo.data?.customFields?.['deal-status'] || 'None Active';
        client.deal_status = clientDealStatus;
      });
    }
  }

  onActionsTrigger(e) {
    e.preventDefault();
    const $trigger = $(e.currentTarget);
    const $row = $trigger.closest('[data-clients-table="row"]');
    const $actionsBody = $row.find('[data-clients-table="actions-body"]');

    $actionsBody.toggleClass('open');
  }

  onActionsDetails(e) {
    e.preventDefault();
    const $target = $(e.currentTarget);
    const $row = $target.closest('[data-clients-table="row"]');
    const $actionsBody = $row.find('[data-clients-table="actions-body"]');
    const clientEmail = $row.data('client-id');
    const client = this.clients.find(c => c.email === clientEmail);

    $actionsBody.removeClass('open');
    
    if (!client) {
      console.error('No client found');
      return;
    }
    const $clientDetailsWrap = Modal.getContentElement('client-details', '.modal_inner');
    const valuesMap = {
      first_name: client.first_name,
      last_name: client.last_name,
      email: client.email,
      phone: client.phone,
      app_status: client.app_status,
      deal_status: client.deal_status,
    };

    const $coappDetailTemplate = $clientDetailsWrap.find('[data-client-detail="coapp"]').first();
    client.coapplicants.forEach((coapp, i) => {
      const $coappDetail = $coappDetailTemplate.clone();
      $coappDetail.attr('data-client-detail', coapp.index);
      $coappDetail.find('[data-client-detail="coapp-name"]').text(`${coapp.first_name || ''} ${coapp.last_name || ''}`.trim());
      $coappDetail.find('[data-client-detail="coapp-email"]').text(coapp.email || '--');
      
      $clientDetailsWrap.find('[data-client-detail="coapp"]').last().after($coappDetail);
    });
    $coappDetailTemplate.remove();

    Object.keys(valuesMap).forEach(key => {
      const $detail = $clientDetailsWrap.find(`[data-client-detail="${key}"]`);
      if ($detail.length) {
        $detail.text(valuesMap[key]);
      } else {
        $detail.text('--');
      }
    });

    Modal.open('client-details');
  }

  onActionsCancel(e) {
    const $target = $(e.currentTarget);
    const $row = $target.closest('[data-clients-table="row"]');
    const $actionsBody = $row.find('[data-clients-table="actions-body"]');

    $actionsBody.removeClass('open');
  }

  render() {
    if (!this.clients.length) {
      const $row = this.getRowTemplate({ name: '--', client_row_id: 0 });
      this.$body.append($row);
      return;
    } else {
      // remove 'no clients found' row
      this.$body.find('[data-clients-table="row"]').each((i, el) => {
        const $el = $(el);
        if ($el.data('client-row-id') == 0) {
          $el.remove();
        }
      });
    }

    this.clients.forEach(client => {
      const $row = this.getRowTemplate(client);
      this.$body.append($row);
    });
  }

  getRowTemplate(client) {
    const $row = this.$tplClone.clone();
    const name = `${client.first_name || ''} ${client.last_name || ''}`;
    $row.attr('data-client-id', client.email);
    $row.find('[data-clients-table="clients-name"]').text(name.trim() || '--');

    const statusClassMap = { 'Approved': 'bg_primary', 'Denied': 'bg_text_light', 'Pending Approval': 'bg_borders' };
    const $appStatusIcon = $row.find('[data-clients-table="client-app-status"] div').first();
    const $appStatusText = $row.find('[data-clients-table="client-app-status"] div').last();
    $appStatusIcon.addClass(statusClassMap[client.app_status] || 'bg_borders');
    $appStatusText.text(client.app_status || 'Pending Approval');

    const dealStatusClassMap = { 'Closed': 'bg_primary', 'Final Terms': 'bg_primary_light', 'Offer Request': 'bg_text_light', 'None Active': 'bg_borders' };
    const $dealStatusIcon = $row.find('[data-clients-table="client-deal-status"] div').first();
    const $dealStatusText = $row.find('[data-clients-table="client-deal-status"] div').last();
    $dealStatusIcon.addClass(dealStatusClassMap[client.deal_status] || 'bg_borders');
    $dealStatusText.text(client.deal_status || 'None Active');
    
    return $row;
  }

  static init() {
    $('[data-js-component="clients-table"]').each((i, el) => new AgentsClientsTable(el));
  }
}

AgentsClientsTable.init();
